import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../../components/_atomic/Button/Button';
import PasswordField from '../../components/_molecules/PasswordField/PasswordField';
import ResetFormContext from './ResetFormContext';
import ErrorModal from '../../components/_molecules/ErrorModal/ErrorModal';
import LoadingOverlay from '../../components/_molecules/LoadingOverlay/LoadingOverlay';
import { CONTEXT_PROVIDERS, TEXT_FIELD_STATUS, publicHash, LOADING, ERROR, SUCCESS } from '../../utils/constants';
import { getSearch, getURLParameters } from '../../utils/helpers';
import './ResetPassword.scss';

const passwordFieldName = 'password';
const passwordConfirmationFieldName = 'password-confirmation';
class ResetPassword extends Component {
  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    resetError: PropTypes.string.isRequired,
    resetStatus: PropTypes.string.isRequired,
    annulError: PropTypes.func.isRequired,
    resetPassword: PropTypes.func.isRequired,
    checkToken: PropTypes.func.isRequired,
    checkError: PropTypes.string.isRequired,
    checkStatus: PropTypes.string.isRequired,
  };

  constructor() {
    super();
    this.fields = {};
  }

  state = {
    formStatus: TEXT_FIELD_STATUS.INITIAL,
    token: '',
    fields: {
      [passwordFieldName]: {
        status: TEXT_FIELD_STATUS.INITIAL,
        isFocused: false,
        value: '',
        errorText: '',
        hint: '',
        needValidator: false,
      },
      [passwordConfirmationFieldName]: {
        status: TEXT_FIELD_STATUS.INITIAL,
        isFocused: false,
        value: '',
        errorText: '',
        hint: '',
        needValidator: false,
      },
    },
  }

  componentWillMount() {
    const search = getSearch();
    const searchObj = getURLParameters(search);
    let { token } = this.state;
    if (searchObj.token) {
      ({ token } = searchObj);
      this.props.checkToken({ token });
    } else {
      this.props.history.push(`${publicHash}/auth/login`);
    }
    this.setState(() => ({
      token,
    }));
  }

  getFormStatus = (fields) => {
    let status = TEXT_FIELD_STATUS.INITIAL;
    let validFields = 0;
    let invalidFields = 0;
    const fieldsNames = Object.keys(fields);
    /* calc invalid fields coz form can have one VALID and one INITIAL field
           then form isn't valid or invalid it is initial */
    fieldsNames.forEach((name) => {
      if (fields[name].status === TEXT_FIELD_STATUS.VALID) {
        validFields += 1;
      }
      if (fields[name].status === TEXT_FIELD_STATUS.INVALID) {
        invalidFields += 1;
      }
    });
    if (validFields === fieldsNames.length) {
      status = TEXT_FIELD_STATUS.VALID;
    }

    if (invalidFields > 0) {
      status = TEXT_FIELD_STATUS.INVALID;
    }
    return status;
  };
  registerField = ({ name, validator }) => {
    this.fields[name] = {
      validator,
    };
  };

  fieldChangeHandler = ({ name, value }) => {
    const fields = { ...this.state.fields };
    let { formStatus } = this.state;
    fields[name].value = value;
    if (name === passwordFieldName) {
      if (fields[name].status !== TEXT_FIELD_STATUS.INITIAL) {
        const { validator } = this.fields[name];

        const validate = validator(fields[name].value);
        fields[name].status = validate.status;
        fields[name].errorText = validate.errorText;
        formStatus = this.getFormStatus(fields);
      }
    }
    if (fields[passwordConfirmationFieldName].status !== TEXT_FIELD_STATUS.INITIAL) {
      const { validator } = this.fields[passwordConfirmationFieldName];
      const validate =
        validator(fields[passwordConfirmationFieldName].value, fields[passwordFieldName].value);
      fields[passwordConfirmationFieldName].status = validate.status;
      fields[passwordConfirmationFieldName].errorText = validate.errorText;
      formStatus = this.getFormStatus(fields);
    }

    this.setState(() => ({ fields, formStatus }));
  };

  fieldFocusHandler = ({ name, isFocused }) => {
    const fields = { ...this.state.fields };
    let { formStatus } = this.state;
    fields[name].isFocused = isFocused;
    if (!isFocused) {
      if (name === passwordFieldName) {
        const { validator } = this.fields[name];
        const validate = validator(fields[name].value);
        fields[name].status = validate.status;
        fields[name].errorText = validate.errorText;
        formStatus = this.getFormStatus(fields);
      }
      if (name === passwordConfirmationFieldName) {
        const { validator } = this.fields[passwordConfirmationFieldName];
        const validate =
          validator(fields[passwordConfirmationFieldName].value, fields[passwordFieldName].value);
        fields[passwordConfirmationFieldName].status = validate.status;
        fields[passwordConfirmationFieldName].errorText = validate.errorText;
        formStatus = this.getFormStatus(fields);
      }
    }
    this.setState(() => ({ fields, formStatus }));
  };

  submitHandler = (e) => {
    e.preventDefault();
    const { token } = this.state;
    const fields = { ...this.state.fields };
    const { validator } = this.fields[passwordFieldName];
    const validate = validator(fields[passwordFieldName].value);
    fields[passwordFieldName].status = validate.status;
    fields[passwordFieldName].errorText = validate.errorText;
    const confirmValidator = this.fields[passwordConfirmationFieldName].validator;
    const confirmValidate =
    confirmValidator(fields[passwordConfirmationFieldName].value, fields[passwordFieldName].value);
    fields[passwordConfirmationFieldName].status = confirmValidate.status;
    fields[passwordConfirmationFieldName].errorText = confirmValidate.errorText;

    const formStatus = this.getFormStatus(fields);
    this.setState(() => ({ fields, formStatus }), () => {
      if (formStatus === TEXT_FIELD_STATUS.VALID) {
        const data = {
          token,
          password: fields[passwordFieldName].value,
        };
        this.props.resetPassword(data);
      }
    });
  }
  navigateToLogin = (e) => {
    e.preventDefault();
    this.props.history.push(`${publicHash}/auth/login`);
  }
  navigateToRestore = (e) => {
    e.preventDefault();
    this.props.history.push(`${publicHash}/auth/restore-password`);
  }
  render() {
    const {
      resetStatus, annulError, resetError, checkError, checkStatus,
    } = this.props;
    const { formStatus, fields } = this.state;
    const isLoading = resetStatus === LOADING || checkStatus === LOADING;
    const isResetError = resetStatus === ERROR;
    const isCheckError = checkStatus === ERROR;
    const disabledButton = formStatus === TEXT_FIELD_STATUS.INVALID;
    const resetFormWrapperClassnames = classNames({
      'reset-form-wrapper': true,
      confirmed: resetStatus === SUCCESS,
    });
    const passwordField = fields[passwordFieldName];
    const passwordConfirmationField = fields[passwordConfirmationFieldName];
    return (
      <div className={resetFormWrapperClassnames}>
        <div className="reset-form-content">
          <form className="reset-form">
            <LoadingOverlay visible={isLoading} />
            <ErrorModal requestClose={annulError} visible={isResetError} error={resetError} />
            <ErrorModal visible={isCheckError} error={checkError} footer={<Button label="Request again" clickHandler={this.navigateToRestore} />} />

            <div className="main-label">
              <span>Set new password</span>
            </div>
            <div className="form-description">
              <span>
                Password should be at least 6 symbols, contain uppercase, lowercase and one
                number. Thereafter you will be redirected to the sign in page.
              </span>
            </div>
            <ResetFormContext.Provider
              value={{
              register: this.registerField,
              changeHandler: this.fieldChangeHandler,
              focusHandler: this.fieldFocusHandler,
            }}
            >
              <PasswordField
                name={passwordFieldName}
                value={passwordField.value}
                status={passwordField.status}
                isFocused={passwordField.isFocused}
                errorText={passwordField.errorText}
                isRequired
                needSpecifiedValidator
                contextProvider={CONTEXT_PROVIDERS.ResetFormContext}
              />
              <PasswordField
                name={passwordConfirmationFieldName}
                value={passwordConfirmationField.value}
                status={passwordConfirmationField.status}
                isFocused={passwordConfirmationField.isFocused}
                errorText={passwordConfirmationField.errorText}
                hint={passwordConfirmationField.hint}
                label="Confirm password"
                isRequired
                needConfirmation
                contextProvider={CONTEXT_PROVIDERS.ResetFormContext}
              />
            </ResetFormContext.Provider>
            <div className="button-wrapper">
              <Button disabled={disabledButton} label="Save" clickHandler={this.submitHandler} />
            </div>
          </form>
          <div className="confirmation-wrapper">
            <div className="main-label">password successfully changed</div>
            <div className="form-description">
              <span>
                    Now you can login with you new password!
              </span>
            </div>
            <div className="link-wrapper" > <Button label="Login" clickHandler={this.navigateToLogin} /></div>
          </div>
        </div>
      </div>
    );
  }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/containers/ResetPassword/ResetPassword.js